<template>
    <v-dialog v-model="dialogComputed" width="900px" @keydown.esc="closeModal(false)"> 
        <v-card>
            <v-container class="no-pd">                
                <v-card-text class="no-pd">
                    <v-img :src="newspaper" />
                </v-card-text>
                <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close--newspaper" @click="closeModal(false)" fab>
                        <span class="modal__container__btn__close--span" :style="{'color': currentCompany.buttonsColor }"> x </span>                    
                    </v-btn>
                </div>
            </v-container>            
        </v-card>
    </v-dialog>
</template>

<script>
//Store
import { mapGetters } from "vuex";

export default {
    name: 'showNewspaper',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
        dialogComputed: {
            get: function() {
                return this.dialog
            },
            set: function() {
                this.closeModal(false)
            }
        }
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        newspaper: {
            type: String,
            required: true
        }
    },
    data: () => ({

    }),
    methods: {
        closeModal(condition) {
            this.$emit('closedShowNewspaper', condition)
        }
    }
}
</script>

<style scoped>
::v-deep .v-dialog {
    border-radius: 12px;
}
.modal__container__btn__close--newspaper {
    padding: 0px !important;
    height: 22px !important;
    width: 22px !important;
    min-width: 22px !important;
}
</style>>